export const GET_DAILY_REPORT='GET_DAILY_REPORT'
export const GET_DAILY_REPORT_SUCCESS='GET_DAILY_REPORT_SUCCESS'
export const GET_DAILY_REPORT_ERROR='GET_DAILY_REPORT_ERROR'

export const GetDailyReport = (data) => ({
    type: GET_DAILY_REPORT,
    payload: data
})